import { EcommerceFlow, ExclusiveFlow, POSFlow, SuiFrensFlow } from 'utils/helper';
import ECACategoryComponent from 'components/Ecommerce/ECTheme/ECAdvance/ECACategoryComponent';
import ECECategoryComponent from 'components/Ecommerce/ECTheme/ECExclusive/ECECategoryComponent';
import ECSCategoryComponent from 'components/Ecommerce/ECTheme/ECSuiFrens/ECSCategoryComponent';
import POSCategoryComponent from 'components/POS/POSCategoryComponent';

const CategoryComponent = ({
  viewName,
  categoryList,
  setCatClick,
  catClick,
  showSideCategories,
  setNewOne,
}: any) => {

  const renderAccordingName = (getTypeName: any) => {
    switch (getTypeName) {
      case SuiFrensFlow:
        return (
          <ECSCategoryComponent
            categoryList={categoryList}
            setCatClick={setCatClick}
            catClick={catClick}
            showSideCategories={showSideCategories}
            setNewOne={setNewOne}
          />
        )
      case ExclusiveFlow:
        return (
          <ECECategoryComponent
            categoryList={categoryList}
            setCatClick={setCatClick}
            catClick={catClick}
            showSideCategories={showSideCategories}
            setNewOne={setNewOne}
          />
        )
      case POSFlow:
        return (
          <POSCategoryComponent
            categoryList={categoryList}
            setCatClick={setCatClick}
            catClick={catClick}
            showSideCategories={showSideCategories}
            setNewOne={setNewOne}
          />
        )
      case EcommerceFlow:
        return (
          <ECACategoryComponent
            categoryList={categoryList}
            setCatClick={setCatClick}
            catClick={catClick}
            showSideCategories={showSideCategories}
            setNewOne={setNewOne}
          />
        )
    }
  }
  return (
    <>{renderAccordingName(viewName)}</>
  );
};

export default CategoryComponent;